package de.katoonerie.content

import androidx.compose.runtime.Composable
import app.softwork.routingcompose.NavLink
import app.softwork.routingcompose.Router
import de.katoonerie.components.Container
import de.katoonerie.contentful.NavigationBar
import de.katoonerie.util.withPreview
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Header
import org.jetbrains.compose.web.dom.Text

@Composable
fun Header(pages: List<NavigationBar.Page>, preview: Boolean) {
    Header {
        Container(attrs = {
            classes("px-4", "mb-8", "text-lg", "font-semibold", "flex", "flex-col", "md:flex-row", "justify-evenly")
        }) {
            val currentPath = Router.current.currentPath.toString()

            NavLink(to = "/".withPreview(preview), attrs = {
                classes("hover:underline", "text-2xl", "p-4", "-md:border-l", "md:border-t", "solid")
                classes(if (currentPath == "/") "border-amber-50" else "border-transparent")
            }) {
                Text("Katoonerie")
            }
            pages.forEach { page ->
                NavLink(to = "/${page.path}".withPreview(preview), attrs = {
                    classes("hover:underline", "p-4", "-md:border-l", "md:border-t", "solid")
                    classes(if (currentPath == "/${page.path}") "border-amber-50" else "border-transparent")
                }) {
                    Text(page.title)
                }
            }
            NavLink(to = "/netzwerk".withPreview(preview), attrs = {
                classes("hover:underline", "p-4", "-md:border-l", "md:border-t", "solid")
                classes(if (currentPath == "/netzwerk") "border-amber-50" else "border-transparent")
            }) {
                Text("Netzwerk")
            }
            A(href = "mailto:katoonerie@gmail.com", attrs = {
                classes("hover:underline", "p-4")
                target(ATarget.Blank)
            }) {
                Text("Kontakt")
            }
        }
    }
}
